import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';
import styles from './RegisterTable.module.css';

function displayValue(value) {
  if (Array.isArray(value)) return value.join(' · ');
  return value === null || value === undefined || value === '' ? '—' : String(value);
}

// Sorting, filtering and pagination remain owned by each register.
export default function RegisterTable({
  rows, columns, sort, onSortChange, onOpen, getRowKey,
  selectedKey, caption, renderCell,
}) {
  function changeSort(key) {
    onSortChange({
      key, direction: sort.key === key && sort.direction === 'asc' ? 'desc' : 'asc',
    });
  }

  return (
    <div className={styles.scroll}>
      <table className={styles.table}>
        <caption className={styles.srOnly}>{caption}</caption>
        <thead><tr>{columns.map(column => (
          <th key={column.key} scope="col"
            aria-sort={sort.key === column.key ? (sort.direction === 'asc' ? 'ascending' : 'descending') : 'none'}>
            <button type="button" className={styles.sort} onClick={() => changeSort(column.key)}>
              {column.label}
              {sort.key !== column.key ? <ChevronsUpDown size={15} aria-hidden="true" /> :
                sort.direction === 'asc' ? <ChevronUp size={15} aria-hidden="true" /> :
                  <ChevronDown size={15} aria-hidden="true" />}
            </button>
          </th>
        ))}</tr></thead>
        <tbody>{rows.map((row, index) => {
          const key = getRowKey(row);
          return (
            <tr key={key + ':' + index} data-selected={key === selectedKey}
              onClick={event => {
                if (event.target instanceof Element &&
                  event.target.closest('button, a, input, select, textarea, [role="button"]')) return;
                onOpen(row);
              }}>
              {columns.map((column, columnIndex) => {
                const value = renderCell
                  ? renderCell(row, column)
                  : displayValue(column.value ? column.value(row) : row[column.key]);
                return <td key={column.key}>
                  {columnIndex === 0 ? (
                    <button type="button" className={styles.open} onClick={event => {
                      event.stopPropagation();
                      onOpen(row);
                    }}>{value}</button>
                  ) : value}
                </td>;
              })}
            </tr>
          );
        })}</tbody>
      </table>
    </div>
  );
}